import { Grid, Typography, Box, SxProps, Theme } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { selectFieldStyles, textFieldStyles } from 'quoting/new-quote/helpers';
import { us_and_canada_states, US_State } from 'shared/constants';
import { CheckBoxField, FormTextField, SelectField } from 'shared/controls';

const alertStyles: SxProps<Theme> = {
  border: '1px solid #0288d1',
  borderRadius: '5px',
  color: '#0288d1',
  backgroundColor: '#e8f4fd',
  padding: 1,
};

export const JobInfo = () => {
  const {
    formState: { errors },
    getValues,
  } = useFormContext();

  return (
    <Grid item xs={12} md={6}>
      <Typography variant='h6' mb={1}>
        Job Information
      </Typography>
      <FormTextField
        sx={textFieldStyles}
        name='jobInfoProjectName'
        label='Project Name *'
        rules={{
          validate: (value: string) => getValues('status') === 'DRAFT' || !!value || 'Project Name is required',
        }}
        error={Boolean(errors?.jobInfoProjectName)}
        helperText={errors?.jobInfoProjectName?.message}
      />
      <Box sx={{ marginTop: 1 }}>
        <FormTextField
          sx={textFieldStyles}
          name='jobInfoCity'
          label='City *'
          rules={{ validate: (value: string) => getValues('status') === 'DRAFT' || !!value || 'City is required' }}
          error={Boolean(errors?.jobInfoCity)}
          helperText={errors?.jobInfoCity?.message}
        />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <SelectField<US_State>
          sx={selectFieldStyles}
          name='jobInfoState'
          label='State *'
          options={us_and_canada_states.sort((p1, p2) => (p1.name > p2.name ? 1 : p1.name < p2.name ? -1 : 0))}
          getOptionLabel={us_state => us_state.name || ''}
          isOptionEqualToValue={(option, value) => {
            if (!option || !value) return true;
            return option.name === value.name;
          }}
          rules={{ validate: (value: string) => getValues('status') === 'DRAFT' || !!value || 'State is required' }}
          error={Boolean(errors?.jobInfoState)}
          helperText={errors?.jobInfoState?.message}
        />
      </Box>
      <Box sx={{ marginTop: 1, display: 'flex', alignItems: 'center' }}>
        <CheckBoxField name='jobInfoFullTruckload' label='Full Truckload?' />
        <Typography sx={alertStyles} variant='body2'>
          Aker minimum quantity is 20 units per order.
        </Typography>
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <FormTextField sx={textFieldStyles} name='jobInfoEstimatedSchedule' label='Estimated Schedule' />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <FormTextField
          sx={textFieldStyles}
          name='jobInfoReleaseAndFirstOrderDate'
          label='Anticipate Release Date & 1st Order Date'
        />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <FormTextField sx={textFieldStyles} name='jobInfoJobDuration' label='Duration of Job' />
      </Box>
    </Grid>
  );
};
